<template>
    <div class="block-editor meta-send-capi-event">
        <div class="wrapper">
            <section>
                <div class="title">{{ $t('auto.metaSendCapiEventContactId') }}</div>
                <TiptapEditor
                    placeholder="Contact ID"
                    :show-attributes="true"
                    :max-character-count="100"
                    v-model="clone.contactId"
                    automation-mode
                />
            </section>

            <section>
                <div class="title">{{ $t('auto.metaSendCapiEventEventTipi') }}</div>
                <a-select class="w-100" :placeholder="$t('auto.metaSendCapiEventEventTipiSeIn')" v-model="clone.eventType">
                    <a-select-option value="LeadSubmitted">{{ $t('auto.metaSendCapiEventLeadGNderildi') }}</a-select-option>
                    <a-select-option value="Purchase">{{ $t('auto.metaSendCapiEventSatNAlma') }}</a-select-option>
                    <a-select-option value="InitiateCheckout">{{ $t('auto.metaSendCapiEventSohbetBaLatLd') }}</a-select-option>
                    <a-select-option value="AppointmentBooked">{{ $t('auto.metaSendCapiEventRandevuOluTuruldu') }}</a-select-option>
                    <a-select-option value="AddToCart">{{ $t('auto.metaSendCapiEventSepeteEklendi') }}</a-select-option>
                    <a-select-option value="ViewContent">{{ $t('auto.metaSendCapiEventErikGRNtLendi') }}</a-select-option>
                    <a-select-option value="OrderCreated">{{ $t('auto.metaSendCapiEventSipariOluTuruldu') }}</a-select-option>
                    <a-select-option value="OrderShipped">{{ $t('auto.metaSendCapiEventSipariKargoyaVerildi') }}</a-select-option>
                </a-select>
            </section>

            <section v-if="['Purchase', 'OrderCreated', 'OrderShipped'].includes(clone.eventType)">
                <div class="title">{{ $t('auto.metaSendCapiEventParaBirimi') }}</div>
                <TiptapEditor
                    placeholder="TRY, USD, EUR"
                    :show-attributes="true"
                    :max-character-count="10"
                    v-model="clone.currency"
                    automation-mode
                />
            </section>

            <section v-if="['Purchase', 'OrderCreated', 'OrderShipped'].includes(clone.eventType)">
                <div class="title">{{ $t('auto.metaSendCapiEventTutar') }}</div>
                <TiptapEditor
                    :placeholder="`Örn: \{\{order_total\}\} veya 99.99`"
                    :show-attributes="true"
                    :max-character-count="50"
                    v-model="clone.value"
                    automation-mode
                />
            </section>

            <section>
                <div class="title">{{ $t('auto.metaSendCapiEventEkBilgilerOpsiyonel') }}</div>
                <div class="custom-data-list">
                    <div v-for="(item, index) in clone.customData" :key="index" class="custom-data-item">
                        <input v-model="item.key" :placeholder="$t('auto.metaSendCapiEventAnahtar')" class="key-input" />
                        <TiptapEditor
                            placeholder="Değer"
                            :show-attributes="true"
                            :max-character-count="200"
                            v-model="item.value"
                            automation-mode
                            class="value-input"
                        />
                        <button @click="removeCustomData(index)" class="remove-btn">
                            <i class="material-icons">delete</i>
                        </button>
                    </div>
                    <button @click="addCustomData" class="add-btn">
                        <i class="material-icons">add</i>
                        {{ $t('auto.metaSendCapiEventEkAlanEkle') }}
                    </button>
                </div>
            </section>

            <div class="info-box">
                <i class="material-icons">info</i>
                <p>
                    {{ $t('auto.metaSendCapiEventCAPIEventiGNdermekIInContactNKanalNdaCapiAyarlarNNYapLmOlmasGerekirBelirtilenContactIdZerindenKanalVeGerekliMetaBilgileriInstagramUserIdMessengerUserIdMetaLeadIdVbOtomatikOlarakAlNacaktR') }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import { mapState } from "vuex";

const log = log2("MetaSendCapiEvent");
export default {
    name: "MetaSendCapiEvent",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
        }),
    },
    methods: {
        addCustomData() {
            if (!Array.isArray(this.clone.customData)) {
                this.clone.customData = [];
            }
            this.clone.customData.push({
                key: "",
                value: "",
            });
        },
        removeCustomData(index) {
            this.clone.customData.splice(index, 1);
        },
    },
    mounted() {
        if (!this.clone.contactId) {
            this.clone.contactId = "{{contact.id}}";
        }
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.meta-send-capi-event {
    section {
        margin-bottom: 10px;
    }

    .wrapper {
        padding: 30px;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .custom-data-list {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .custom-data-item {
                display: flex;
                gap: 10px;
                align-items: flex-start;

                .key-input {
                    width: 30%;
                    padding: 8px 12px;
                    border: 1px solid #d9d9d9;
                    border-radius: 4px;
                    font-size: 14px;

                    &:focus {
                        outline: none;
                        border-color: #40a9ff;
                        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
                    }
                }

                .value-input {
                    flex: 1;
                }

                .remove-btn {
                    padding: 8px;
                    border: none;
                    background: #ff4d4f;
                    color: white;
                    border-radius: 4px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s;
                    margin-top: 5px;

                    &:hover {
                        background: #ff7875;
                    }

                    i {
                        font-size: 18px;
                    }
                }
            }

            .add-btn {
                width: fit-content;
                padding: 8px 16px;
                border: 1px dashed #d9d9d9;
                background: white;
                border-radius: 4px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 5px;
                transition: all 0.2s;

                &:hover {
                    border-color: #40a9ff;
                    color: #40a9ff;
                }

                i {
                    font-size: 16px;
                }
            }
        }

        .info-box {
            display: flex;
            gap: 10px;
            padding: 12px;
            background: #e3f2fd;
            border-radius: 6px;
            border-left: 4px solid #2196f3;
            margin-top: 15px;

            i {
                color: #2196f3;
                font-size: 20px;
            }

            p {
                margin: 0;
                font-size: 13px;
                color: #1565c0;
                line-height: 1.5;
            }
        }
    }
}
</style>

